/* --- section-stacked-scroll-banners.js --- */

class StackedScrollBanners extends HTMLElement {
  constructor() {
    super();
    this.slides = [];
    this.slideElements = []; // NOUVEAU : On va stocker les éléments HTML ici pour la performance
    this.currents = [];
    this.ticking = false;    // NOUVEAU : Variable pour optimiser l'écoute du scroll
    
    // Liaison des méthodes à la classe (bind)
    this._onScroll = this._onScroll.bind(this);
    this._loop = this._animationLoop.bind(this);
  }

  connectedCallback() {
    // 1. On récupère toutes les bannières
    this.slides = Array.from(this.querySelectorAll('[data-stacked-slide]'));
    if (!this.slides.length) return;

    // 2. On récupère la hauteur RÉELLE de la première slide
    this._slideHeight = this.slides[0].offsetHeight;
    
    // 3. Initialisation et mise en cache (Performance)
    this.slides.forEach((slide) => {
      // On sauvegarde les éléments cibles une seule fois au chargement
      this.slideElements.push({
        content: slide.querySelector('.stacked-scroll-banner__content'),
        overlay: slide.querySelector('.stacked-scroll-banner__overlay'), // Nom de classe corrigé !
        img: slide.querySelector('.stacked-scroll-banner__image')
      });
      
      // On prépare les valeurs d'animation par défaut
      this.currents.push({ pushY: 0, opacity: 1, overlay: 0, parallax: 0 });
    });

    // 4. Écouteurs d'événements
    // Optimisation : On empêche le scroll de déclencher les calculs trop de fois d'un coup
    window.addEventListener('scroll', () => {
      if (!this.ticking) {
        window.requestAnimationFrame(() => {
          this._onScroll();
          this.ticking = false;
        });
        this.ticking = true;
      }
    }, { passive: true });

    // Si on redimensionne l'écran (ex: passage paysage/portrait), on recalcule la hauteur
    window.addEventListener('resize', () => {
        this._slideHeight = this.slides[0].offsetHeight;
        this._onScroll();
    }, { passive: true });

    // 5. On lance le premier calcul et la boucle d'animation
    this._onScroll();
    this._animationLoop();
  }

  _onScroll() {
    const scrollY = window.scrollY;
    // On calcule la position du haut de notre section globale par rapport à la page
    const trackTop = this.getBoundingClientRect().top + scrollY;

    this.slides.forEach((slide, i) => {
      // CONDITION : Si c'est le dernier slide, on ne touche à rien (il reste en place)
      if (i === this.slides.length - 1) {
        this.currents[i] = { pushY: 0, opacity: 1, overlay: 0, parallax: 0 };
        return;
      }

      // Position du slide suivant basée sur la hauteur réelle
      const nextSlideTop = trackTop + (i + 1) * this._slideHeight;
      const distanceToNext = nextSlideTop - scrollY;

      // ANIMATION : Si le slide suivant est en train d'arriver par-dessus
      if (distanceToNext <= this._slideHeight && distanceToNext > 0) {
        // progress va de 0 (début du recouvrement) à 1 (totalement recouvert)
        const progress = 1 - (distanceToNext / this._slideHeight);

        // 1. POUSSÉE DU CONTENU (Le texte monte doucement)
        this.currents[i].pushY = progress * -this._slideHeight; 
        
        // 2. FADE OUT (Le texte disparaît)
        this.currents[i].opacity = 1 - (progress * 1.5);
        
        // 3. OVERLAY (L'image s'assombrit en arrière-plan)
        this.currents[i].overlay = progress * 0.7;

        // 4. IMAGE PARALLAXE : L'image monte légèrement vers le haut
        this.currents[i].parallax = progress * -20;
      } 
      // FIN D'ANIMATION : Le slide est totalement recouvert
      else if (distanceToNext <= 0) {
        this.currents[i].pushY = -this._slideHeight;
        this.currents[i].opacity = 0;
        this.currents[i].overlay = 0.7;
        this.currents[i].parallax = -10;
      } 
      // AVANT ANIMATION : Le slide suivant est encore loin
      else {
        this.currents[i].pushY = 0;
        this.currents[i].opacity = 1;
        this.currents[i].overlay = 0;
        this.currents[i].parallax = 0;
      }
    });
  }

  _animationLoop() {
    // Cette boucle tourne à 60 images par seconde
    this.slideElements.forEach((els, i) => {
      
      // On applique le mouvement et l'opacité sur le texte
      if (els.content) {
        els.content.style.transform = `translate3d(0, ${this.currents[i].pushY}px, 0)`;
        els.content.style.opacity = Math.max(0, this.currents[i].opacity);
      }
      
      // On applique l'opacité sur le voile noir (assombrissement)
      if (els.overlay) {
        els.overlay.style.opacity = this.currents[i].overlay;
      }
      
      // On applique la translation (montée) sur l'image
      if (els.img) {
        els.img.style.transform = `translate3d(0, ${this.currents[i].parallax}%, 0)`;
      }
    });
    
    // On relance la boucle pour l'image suivante (crée l'effet fluide)
    requestAnimationFrame(this._loop);
  }
}

// Enregistrement du composant Web (Custom Element) dans Shopify
if (!customElements.get('stacked-scroll-banners')) {
    customElements.define('stacked-scroll-banners', StackedScrollBanners);
}